export const environment = {
    production: false,
    backend_domain: "https://stagapi.exploremoredfw.com/api/",
    appstore_link: "https://apps.apple.com/us/app/trailbingo-by-exploremore/id6473724566",
    playstore_link: "https://play.google.com/store/apps/details?id=com.exploremore.TrailBingo&pli=1",
    version: '1.26.0',
    deeplink_domain: `https://links.exploremore.fun/splash-screen.html`
};
